export default __webpack_public_path__ + "static/media/bubble-09.f6e7c66f.png";